import React from 'react';
import Button from 'react-bootstrap/Button';
import { ArrowUpward } from '@mui/icons-material';

const SortAscButton = ({ active = false, onClick, title = 'Sort ascending' }) => {
  return (
    <Button
      type="button"
      variant={active ? 'primary' : 'outline-secondary'}
      size="sm"
      onClick={onClick}
      title={title}
      aria-label={title}
      style={{
        padding: '0.03rem 0.14rem',
        lineHeight: 1,
        minWidth: '1.35rem',
        fontSize: '0.72rem',
      }}
    >
      <ArrowUpward fontSize="inherit" />
    </Button>
  );
};

export default SortAscButton;
